<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">ระดับพนักงาน</span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!employeeLevelFormShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-btn
            :disabled="
              uiCtrl && !uiCtrl.isEnable('btn:::employee_level:create')
            "
            style="margin-top: 1px"
            color="primary"
            @click="handleAddEmployeeLevelForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มระดับพนักงาน
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="employeeLevels"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
    </v-data-table>
    <EmployeeLevelForm
      :formShow="employeeLevelFormShow"
      :formAction="employeeLevelFormAction"
      :employeeLevel="employeeLevel"
      :employeeLevelInit="employeeLevelInit"
      @isEmployeeLevelDataChange="handleEmployeeLevelFormDataChange"
      @formActionCompleted="handleEmployeeLevelFormActionCompleted"
      @onReset="handleEmployeeLevelFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="employeeLevelFormShow && employeeLevelFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import EmployeeLevelForm from '@/views/employee-level/EmployeeLevelForm.vue'

export default {
  components: {
    EmployeeLevelForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['employee_level_code'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        {
          text: 'รหัสระดับพนักงาน',
          align: 'start',
          value: 'employee_level_code',
          width: 150,
        },
        { text: 'คำอธิบาย', value: 'title_th' },
        { text: 'คำอธิบาย (en)', value: 'title_en' },
      ],
      employeeLevelFormShow: false,
      employeeLevelFormAction: '',
      employeeLevel: {},
      employeeLevelInit: {},
      isEmployeeLevelDataChange: false,
      interval: null,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    employeeLevels() {
      return this.$store.state.employeeLevel.employeeLevels
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ระดับพนักงาน',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchEmployeeLevels: 'employeeLevel/fetchEmployeeLevels',
    }),
    classRowSelected(row) {
      if (this.employeeLevel.employee_level_uuid === row.employee_level_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::employee_level:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.employeeLevel.employee_level_uuid === row.employee_level_uuid) {
        this.employeeLevelFormShow = false
        this.employeeLevelFormAction = ''
        this.employeeLevel = {}
        this.employeeLevelInit = {}
      } else {
        this.employeeLevelFormShow = true
        this.employeeLevelFormAction = 'edit'
        this.employeeLevel = { ...row }
        this.employeeLevelInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isEmployeeLevelDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddEmployeeLevelForm() {
      this.employeeLevelFormShow = true
      this.employeeLevelFormAction = 'add'
      this.employeeLevel = {}
      this.employeeLevelInit = {}
    },
    handleEmployeeLevelFormDataChange(value) {
      this.isEmployeeLevelDataChange = value
    },
    handleEmployeeLevelFormReset(formAction) {
      if (formAction === 'edit')
        this.employeeLevel = { ...this.employeeLevelInit }
    },
    handleEmployeeLevelFormActionCompleted(formAction) {
      this.employeeLevel = {}
      this.employeeLevelInit = {}
      this.employeeLevelFormShow = false
      this.employeeLevelFormAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = { company_uuid }
      const employeeLevels = this.fetchEmployeeLevels(payload)

      Promise.all([employeeLevels])
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.employeeLevelFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEmployeeLevelDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
